import React, { Component } from "react";
import PropTypes from "prop-types";
import { dollars } from "LIB/formatters/currency";
import { alphaMonthYear } from "LIB/formatters/date";
import { CONDITION, INVENTORIES } from "MODULES/inventories/constants";
import { INVENTORY_ID } from "APP_ROOT/constants";

export default class InventoryTable extends Component {
  static propTypes = {
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        quantity: PropTypes.number,
        condition: PropTypes.string
      })
    ).isRequired
  };

  handleChange = ({
    id,
    condition,
    correct_serial_number: correctSerialNumber,
    quantity,
    incoming_awb_number: incomingAWB,
    date_received: dateReceived,
    condition_received: conditionReceived,
    serial_number: serialNumber,
    serial_number_correction_required: serialNumberCorrectionRequired
  }) => {
    this.props.setField(INVENTORY_ID, id);
    this.props.setField(CONDITION, condition);
    this.props.setField("condition_received", conditionReceived);
    this.props.setField("incoming_awb_number", incomingAWB);
    this.props.setField("quantity", quantity);
    this.props.setField("date_received", dateReceived);
    this.props.setField("cancelled", false);
    if (serialNumberCorrectionRequired) {
      this.props.setField(
        "external_note",
        `Please reidentify Serial # ${serialNumber}. The correct Serial # appears to be ${correctSerialNumber}`
      );
    }
  };

  renderRow = (lineItem, i) => (
    <tr key={i}>
      <td>{i + 1}</td>
      <td className="text-center">
        <input
          type="radio"
          name="read_only_inv"
          className="radio-inline"
          checked={lineItem.id === this.props.getField(INVENTORY_ID)}
          onChange={() => {
            this.handleChange(lineItem);
            this.props.notifyForm(lineItem);
          }}
        />
      </td>
      <td>{lineItem.serial_number}</td>
      <td>
        {lineItem.condition && INVENTORIES.condition[lineItem.condition].abbrev}
      </td>
      <td>{lineItem.quantity}</td>
      <td>{alphaMonthYear(lineItem.tag_date)}</td>
      <td>
        {lineItem.srp_condition &&
          INVENTORIES.condition[lineItem.srp_condition].abbrev}
      </td>
      <td className="text-right">
        {lineItem.suggested_retail && dollars(lineItem.suggested_retail)}
      </td>
      <td className="text-right">
        {lineItem.exchange_srp && dollars(lineItem.exchange_srp)}
      </td>
      <td className="text-right">
        {lineItem.cost_per_unit && dollars(lineItem.cost_per_unit)}
      </td>
    </tr>
  );

  render() {
    return (
      <div className="col-md-12">
        <table className="table table-striped table-hover table-numbered">
          <thead>
            <tr>
              <th />
              <th />
              <th>Serial Number</th>
              <th>CD</th>
              <th>QTY</th>
              <th>Tag Date</th>
              <th>SRP CD</th>
              <th className="text-right">SRP</th>
              <th className="text-right">Exch SRP</th>
              <th className="text-right">Cost EA.</th>
            </tr>
          </thead>
          <tbody>{this.props.results.map(this.renderRow)}</tbody>
        </table>
      </div>
    );
  }
}

InventoryTable.propTypes = {
  results: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  notifyForm: PropTypes.func,
  setField: PropTypes.func,
  getField: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/PartDetailsSection/InventoryTable.jsx